import script from "./ExercisesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ExercisesTable.vue?vue&type=script&setup=true&lang=js"

import "./ExercisesTable.vue?vue&type=style&index=0&id=590c4312&lang=scss"

const __exports__ = script;

export default __exports__